/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TextRegularAi from './text-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TextRegularAi {...validProps} />;
}
SvgComponent.iconName = 'textRegularAi';

export const TextRegularAiIcon = svgIconWrapper(SvgComponent);
